import MyApps from './MyApps'
import MoreApps from './MoreApps'
import { useEffect, useMemo, type VFC } from 'react'
import { RUNNING } from '../../utils/common'
import { loadTsgInstances } from '../../../common/utils/Sparky'
import type { InstancesAndApps, ReadonlyTsgInstances, Tsg, AppFilters } from '../../types'

const INTERVAL = 30000 // 30s
const { setTimeout, clearTimeout } = window
const useInstancesRefresh = (tsgId: string, instances: ReadonlyTsgInstances) => {
  const needToPollStatus = useMemo(() => !instances.every((inst) => inst.status === RUNNING && inst.url), [instances])
  useEffect(() => {
    if (!needToPollStatus) {
      return
    }
    let timer = 0
    const loadInstances = () => {
      if (timer) {
        clearTimeout(timer)
        timer = 0
      }
      loadTsgInstances(tsgId).then(setTimer, setTimer)
    }
    const setTimer = () => {
      if (timer) {
        clearTimeout(timer)
        timer = 0
      }
      timer = setTimeout(loadInstances, INTERVAL)
    }
    const eventHandler = () => {
      if (!document.hidden) {
        loadInstances()
      }
    }
    window.addEventListener('focus', eventHandler, false)
    document.addEventListener('visibilitychange', eventHandler, false)
    setTimer()
    return () => {
      if (timer) {
        clearTimeout(timer)
      }
      window.removeEventListener('focus', eventHandler, false)
      document.removeEventListener('visibilitychange', eventHandler, false)
    }
  }, [tsgId, needToPollStatus])
}

const HubHome: VFC<InstancesAndApps & AppFilters & { tsg: Tsg }> = ({ instances, apps, tsg, appFilterFn, appAccessFilterFn }) => {
  useInstancesRefresh(tsg.id, instances)
  return <>
    <MyApps instances={instances} apps={apps} tsg={tsg} appAccessFilterFn={appAccessFilterFn} />
    <MoreApps apps={apps} instances={instances} appFilterFn={appFilterFn} appAccessFilterFn={appAccessFilterFn} />
  </>
}

export default HubHome
